import { call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import { fetchEntity } from '@classpass/saga-tools';

import { selectUserVenueIds } from 'selectors/general';
import { makePath } from 'helpers/link-generation';
import { reportsSchedules as reportsSchedulesEntity } from 'store/saga/entities/bound';
import { REPORT_TYPES } from 'features/Stats/Stats.constants';

import {
  CHANGE_FILTER_CLASS,
  CHANGE_FILTER_DATE_END,
  CHANGE_FILTER_DATE_START,
  CHANGE_FILTER_START_TIME,
  CHANGE_FILTER_VENUE,
  CHANGE_PAGE,
  TOGGLE_SORT_DIRECTION,
  resetPage,
  setFields,
  setFieldsEntry,
} from './Schedules.reducers';
import { selectReportsSchedulesControls, selectReportsSchedules } from './Schedules.selectors';
import { constructParamsSchedulesTable } from '../Stats.helpers';

export const NAVIGATE_TO_SCHEDULE_REPORT = 'reports/schedules/NAVIGATE_TO_SCHEDULE_REPORT';
export const navigateToScheduleReport = scheduleId => ({
  type: NAVIGATE_TO_SCHEDULE_REPORT,
  scheduleId,
});

export function* handleEntityCall(dependencies) {
  const params = yield select(selectReportsSchedulesControls);
  const { classIds: startingClassNameToClassIdsMap } = yield select(selectReportsSchedules);
  const bodyParams = constructParamsSchedulesTable(params, startingClassNameToClassIdsMap);

  yield call(fetchEntity, reportsSchedulesEntity, [dependencies, bodyParams]);

  const { classIds: classNameToClassIdsMap, startTimes } = yield select(selectReportsSchedules);
  yield put(setFields(Object.keys(classNameToClassIdsMap).sort(), startTimes.sort()));
}

export function* handleRouteEnter(dependencies) {
  const { hasBeenVisited } = yield select(selectReportsSchedulesControls);
  if (!hasBeenVisited) {
    const venues = yield select(selectUserVenueIds);
    yield put(setFieldsEntry(venues));
    yield call(handleEntityCall, dependencies);
  }
}

export function* handleChangeField(dependencies, action) {
  // changing any filter or sort should reset you to first page because all the individual schedules will shift unpredictably from page to page
  const { type } = action;
  if (type !== CHANGE_PAGE) {
    yield put(resetPage());
  }
  yield call(handleEntityCall, dependencies);
}

export function* handleNavigateToScheduleReport(dependencies, action) {
  const { scheduleId } = action;
  const newPath = makePath.reports({
    reportType: REPORT_TYPES.CLASSES,
    id: scheduleId,
  });
  yield call(dependencies.navigate, newPath);
}

export function* watchActions(dependencies) {
  yield takeLatest(CHANGE_FILTER_DATE_START, handleChangeField, dependencies);
  yield takeLatest(CHANGE_FILTER_DATE_END, handleChangeField, dependencies);
  yield takeLatest(CHANGE_FILTER_VENUE, handleChangeField, dependencies);
  yield takeLatest(CHANGE_FILTER_CLASS, handleChangeField, dependencies);
  yield takeLatest(CHANGE_FILTER_START_TIME, handleChangeField, dependencies);
  yield takeLatest(CHANGE_PAGE, handleChangeField, dependencies);
  yield takeLatest(TOGGLE_SORT_DIRECTION, handleChangeField, dependencies);
  yield takeEvery(NAVIGATE_TO_SCHEDULE_REPORT, handleNavigateToScheduleReport, dependencies);
}
